// extracted by mini-css-extract-plugin
export default {"loader_box":"Loader_loader_box__Q1+gv","loader":"Loader_loader__iMGxA"};